// Format UTC date helper - no timezone conversion for date only fields
// Returns "1/1/2025" (or "January 1, 2025" if long)
export function formatUTCDate(dateString: string | null | undefined, format: 'short' | 'long' = 'short'): string {
  if (!dateString) return '—';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      ...(format === 'short'
        ? { year: 'numeric', month: 'numeric', day: 'numeric' }
        : { year: 'numeric', month: 'long', day: 'numeric' }),
      timeZone: 'UTC',
    });
  } catch {
    return '—';
  }
}

// Format date and time in local timezone
// Returns:
// short: "01/01/2025 12:00 A.M."
// long: "January 1, 2025 12:00 A.M."
// date: "01/01/2025"
// time: "12:00 A.M."
export function formatLocalDateTime(
  dateString: string | Date | null | undefined,
  display: 'date' | 'time' | 'date-time' = 'date-time',
  format: 'short' | 'long' | 'date' = 'short',
): string {
  if (!dateString) return '—';
  try {
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;
    if (Number.isNaN(date.getTime())) return '—';

    const formattedDate = date.toLocaleDateString('en-US', {
      ...(format === 'long' ? { month: 'long', day: 'numeric' } : { month: '2-digit', day: '2-digit' }),
      year: 'numeric',
    });

    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    if (display === 'date') {
      return formattedDate;
    }

    if (display === 'time') {
      return formattedTime;
    }

    return `${formattedDate} ${formattedTime}`;
  } catch {
    return '—';
  }
}

// Get date key for grouping (YYYY-MM-DD)
export function getDateKey(dateString: string | Date | null | undefined): string {
  if (!dateString) return '';
  try {
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US'); // Returns MM/DD/YYYY in local timezone
  } catch {
    return '';
  }
}
